<button *ngIf="options.closeButton" (click)="remove()" class="toast-close-button sam-margin-right" aria-label="Close">
   <span aria-hidden="true">&times;</span>
</button>
<div class="container sam-center">
   <div fxFlex="0 0 15" class="icon-container sam-center fa-layers">
      <fa-icon [icon]="phoneIcon" size="2x"></fa-icon>
      <fa-icon [icon]="hourGlassIcon" class="hourglass-icon"></fa-icon>
   </div>
   <div fxFlex="1 1 100">
      <div class="waiting-title">{{ title }}</div>

      <div [innerHTML]="message"></div>
   </div>
</div>
